<template>
  <div style="padding:20px;">
    <div class="supplier">
      <div v-for="(item, index) in resellerList">
        <el-button style="margin: 10px;" :type="checkedButton === index ? 'primary' : ''"
                   @click="getResellerAccountDetail(item, index)" size="small">{{ item.name }}
        </el-button>
      </div>
    </div>
    <div class="account letter_bold hand">
      <div class="balance center bg_color">
        <div>
          <p class="fz180">账户余额</p>
          <p style="display:flex;justify-content:center;align-items:center;" class="pt5">{{ Balance }}</p>
        </div>
      </div>
      <div class="freeze center bg_color">
        <div>
          <p class="fz180">交易金额冻结中</p>
          <p style="display:flex;justify-content:center;align-items:center;" class="pt5">{{ Forzen }}</p>
        </div>
      </div>
      <div class="check center bg_color">
        <div>
          <p class="fz180">提款审核中</p>
          <p style="display:flex;justify-content:center;align-items:center;" class="pt5">{{ WithDraw }}</p>
        </div>
      </div>
    </div>
    <div>
      <el-button @click="applyMoney" v-if="isApplyShow" type="success" size="small">申请提款</el-button>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="账户明细" name="first">
        <account-detail v-if="activeName === 'first'" :sellerId="currentAccountId"></account-detail>
      </el-tab-pane>
      <el-tab-pane label="冻结中明细" name="second">
        <freeze-detail :sellerId="currentAccountId" v-if="activeName === 'second'"></freeze-detail>
      </el-tab-pane>
      <el-tab-pane label="提款审核中明细" name="third">
        <check-detail :sellerId="currentAccountId" v-if="activeName === 'third'"></check-detail>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="申请提现" :visible.sync="invoiceDialog" width="40%" :show-close="false"
               :close-on-click-modal="false">
      <p style="margin-left: 63px;margin-bottom: 10px;">
        <span style="font-size: 20px;
    font-weight: bold;">账户信息</span>
        <span style="color: red;display:inline-block;margin-left: 20px;">  *请确认提现至银行卡信息!</span>
      </p>
      <el-form :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item prop="bankCardNo" label="银行卡号">
          <el-input size="small" v-model="form.bankCardNo"></el-input>
        </el-form-item>
        <el-form-item prop="bankName" label="开户银行">
          <el-input maxlength="30" size="small" v-model="form.bankName"></el-input>
        </el-form-item>

        <el-form-item prop="invoiceAddress" label="开户地址">
          <!-- 省 -->
          <el-select v-model="provinceName" placeholder="请选择省" @change="handleProvince" style="width: 150px;"
                     value-key="id">
            <el-option v-for="item in provinceList" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
          <!-- 市 -->
          <el-select value-key="id" v-model="cityName" placeholder="请选择市" @change="handleCity"
                     style="width: 150px;">
            <el-option v-for="item in cityList" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
          <!-- 区 -->
          <el-select value-key="id" v-model="countyName" placeholder="请选择区" @change="handleArea"
                     style="width: 150px;">
            <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
          <!--          &lt;!&ndash; 街道 &ndash;&gt;-->
          <!--          <el-select v-model="townName" placeholder="请选择街道" @change="handleStreet" style="width: 150px;"-->
          <!--                     value-key="id">-->
          <!--            <el-option v-for="item in streetList" :key="item.id" :label="item.name" :value="item"></el-option>-->
          <!--          </el-select>-->
        </el-form-item>
        <el-form-item prop="bankConcreteName" label="具体开户行">
          <el-input maxlength="30" size="small" v-model="form.bankConcreteName"></el-input>
        </el-form-item>
        <!--        <el-form-item prop="invoiceBankAccount" label="具体开户行">-->
        <!--          <el-input size="small" v-model="form.invoiceBankAccount"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item prop="cardholderName" label="持卡人姓名">
          <el-input maxlength="10" size="small" v-model="form.cardholderName"></el-input>
        </el-form-item>
        <!--        <el-form-item prop="billingNum" label="本次开票订单数">-->
        <!--          <el-input :disabled=true size="small" v-model="form.billingNum"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item prop="billingAmount" label="提现金额">
          <el-input size="small" v-model="form.amount"></el-input>
        </el-form-item>
        <p>可提现金额: &nbsp;&nbsp;&nbsp;{{ '￥' + this.Balance }}</p>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('form')">取 消</el-button>
        <el-button type="primary" @click="invoiceConfirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AccountDetail from './AccountDetail.vue'
import CheckDetail from "./CheckDetail.vue";
import FreezeDetail from './FreezeDetail.vue'
import {getButtonList} from "../../promissionRouter";
import {
  ApplyWithdrawal,
  CapitalAccountGet,
  GetAllArea,
  GetAllReseller,
  GetAreaTree, WithdrawalOrderGetList
} from "../../api/api";
import resolve from "resolve";

export default {
  components: {
    AccountDetail, CheckDetail, FreezeDetail
  },
  created() {
    this.getAllDistributors()
    this.getProvinceList()
  },
  mounted() {
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    buttonList && buttonList.forEach((item, index) => {
      if (item.buttonFunc === 'applyMoney') {
        this.isApplyShow = true;
      }
    })
    console.log('******', buttonList)
    // if (buttonList && buttonList.length > 0) {
    //   const toolBarButtonList = buttonList.filter((item) => {
    //     return item.buttonShow === 10;
    //   });
    //   this.buttonList_toolBar = toolBarButtonList;
    //   console.log('buttonList_toolBar: ' + this.buttonList_toolBar)
    //   const tableButtonList = buttonList.filter((item) => {
    //     return item.buttonShow === 20;
    //   });
    //   this.buttonList_table = tableButtonList;
    //   console.log('tableButtonList: ' + this.buttonList_table)
    // }
  },
  name: "Index",
  data() {
    return {
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],
      isApplyShow: false,
      Balance: null,
      Forzen: null,
      WithDraw: null,
      currentResellerId: null,
      currentAccountId: null,
      checkedButton: 0,
      resellerList: [],
      isAccountExportShow: false,
      isAccountDetailShow: false,
      isFreezeDetailShow: false,
      buttonList_toolBar: [],
      buttonList_table: [],
      activeName: 'first',
      provinceName: null,
      cityName: null,
      countyName: null,
      townName: null,
      provinceId: null,
      cityId: null,
      countyId: null,
      townId: null,
      form: {
        amount: null,
        capitalAccountId: null,
        bankCardNo: '',
        bankName: '',
        bankConcreteName: '',
        cardholderName: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        districtId: null,
        district: null,
      },
      rules: {
        bankCardNo: [
          {required: true, message: '请输入银行卡号', trigger: 'blur'}
        ],
        bankName: [
          {required: true, message: '请输入开户行, 字数限制30字符以内', trigger: 'blur'}
        ],
        bankConcreteName: [
          {required: true, message: '请输入具体开户行, 字数限制30字符以内', trigger: 'blur'}
        ],
        cardholderName: [
          {required: true, message: '请输入持卡人姓名, 字数限制10个字符以内', trigger: 'blur'}
        ],
        amount: [
          {required: true, message: '请输入提现金额', trigger: 'blur'}
        ]
      },
      invoiceDialog: false
    }
  },
  methods: {
    getCityList(id) {
      let that = this;
      let params = {
        MaxLevel: 2,
        parentId: id ? id : that.provinceId,
      };
      GetAreaTree(params).then((res) => {
        console.log('cityList', res)
        // that.cityList = res.data.response.data;
        res.data.result.children.forEach(item => {
          item.id = item.data.Id;
          item.label = item.data.Name;
          item.ParentId = item.data.ParentId;
          delete item.data;
          delete item.children;
        })
        this.cityList = res.data.result.children;
        console.log('cityList', res.data.result.children);
      });
    },
    handleStreet(e) {
      let that = this;
      that.townName = e.name;
      that.townId = e.id;
    },
    handleProvince(e) {
      console.log('e--province', e);
      let that = this;
      this.provinceName = e.label;
      this.cityName = null;
      this.countyName = null;
      this.townName = null;
      this.provinceId = e.id;
      this.cityId = null;
      this.countyId = null;
      this.townId = null;
      this.getCityList(e.id);
    },
    getAreaList(id) {
      let params = {
        MaxLevel: 3,
        parentId: id ? id : this.cityId,
      };
      GetAllArea(params).then((res) => {
        // console.log('areaList----', res);
        // this.areaTreeList = this.loopTree(res.data.result.children);
        // res.data.result.items.forEach(item=>{
        //   item.id = item.id;
        //   item.label = item.name;
        //   item.ParentId = item.data.ParentId;
        // })
        this.areaList = res.data.result.items;
        console.log('areaList----', res.data.result.items);
      });
    },
    handleArea(e) {
      let that = this;
      that.countyName = e.name;
      that.townName = null;
      that.countyId = e.id;
      that.townId = null;
      // that.getStreetList(e.Id);
    },
    //获取街道
    getStreetList(id) {
      let that = this;
      let params = {
        areaLevel: 4,
        parentId: id ? id : that.countyId,
      };
      console.log('params', params)
      GetAllArea(params).then((res) => {
        console.log('街道', res);
        that.streetList = res.data.result.items;
      });
    },
    handleCity(e) {
      let that = this;
      this.cityName = e.label;
      this.countyName = null;
      this.townName = null;
      this.cityId = e.id;
      this.countyId = null;
      this.townId = null;
      this.getAreaList(e.id);
    },
    getProvinceList() {
      let params = {
        MaxLevel: 1
      };
      GetAreaTree(params).then((res) => {
        // this.areaTreeList = this.loopTree(res.data.result.children);
        res.data.result.children.forEach(item => {
          item.id = item.data.Id;
          item.label = item.data.Name;
          item.ParentId = item.data.ParentId;
          delete item.data;
          delete item.children;
        })
        this.provinceList = res.data.result.children;
        console.log('province----', res.data.result.children);
      });
    },
    invoiceConfirm(formName) {
      // if (Number(this.form.billingAmount) < 100) {
      //   return this.$message.error('单笔提现金额需要大于100元');
      // }
      // return;
      this.form.province = this.provinceName
      this.form.provinceId = this.provinceId
      this.form.city = this.cityName
      this.form.cityId = this.cityId
      this.form.districtId = this.countyId
      this.form.district = this.countyName
      this.form.capitalAccountId = this.currentAccountId
      if (!this.form.provinceId) return this.$message.error('请完善开户省份')
      if (!this.form.cityId) return this.$message.error('请完善开户城市')
      if (!this.form.districtId) return this.$message.error('请完善开户所在区')
      if (!this.form.capitalAccountId) return this.$message.error('缺少账户Id')
      if (!Number(this.form.amount)) return this.$message.error('请输入提现金额')
      if (Number(this.form.amount) == 0) return this.$message.error('当前账户提现金额不能为0')
      if (Number(this.form.amount) < 100) return this.$message.error('单笔提现金额需要大于100元')
      if (Number(this.form.amount) > this.Balance) return this.$message.error(`提现余额不能大于当前账户余额${this.Balance}元`)
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // let myreg = /^1[34578]\d{9}$/;
          // // let myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
          // if (!myreg.test(this.form.invoiceMobile)) {
          //   return this.$message.error('手机号有误, 请重试')
          // }
          this.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(async () => {

            let res = await ApplyWithdrawal(this.form);
            console.log('提现结果', res);
            if (res.data.success) {
              this.invoiceDialog = false;
              // this.currentRow = [];
              this.$refs[formName].resetFields();
              // this.form.billingNum = null;
              // this.form.financeBillingOrderIds = [];
              // this.form.billingAmount = null;
              // this.$refs.tables.clearSelection();
              // this.$message.success(res.data.)
              // this.$refs.tables.clearSelection();
              // this.invoiceDialog = false
              this.form = {
                capitalAccountId: null,
                bankCardNo: '',
                bankName: '',
                bankConcreteName: '',
                cardholderName: '',
                provinceId: '',
                province: '',
                cityId: '',
                city: '',
                districtId: null,
                district: null,
              }
              this.provinceId = null
              this.provinceName = null
              this.cityId = null
              this.cityName = null
              this.countyId = null
              this.countyName = null
              await this.getAllDistributors();
            } else {
              that.$message.error(res.data.error.message || '获取数据失败, 请重试')
            }
          }).catch(() => {
            console.log('er')
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form = {
        amount: null,
        capitalAccountId: null,
        bankCardNo: '',
        bankName: '',
        bankConcreteName: '',
        cardholderName: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        districtId: null,
        district: null,
      }
      this.provinceId = null
      this.provinceName = null
      this.cityId = null
      this.cityName = null
      this.countyId = null
      this.countyName = null
      // this.form.billingNum = null;
      // this.form.financeBillingOrderIds = [];
      // this.currentRow = [];
      // this.form.billingAmount = null;
      this.invoiceDialog = false;
      // this.$refs.tables.clearSelection();
    },
    async getAccountInfo() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 10,
        CapitalAccountId: this.currentAccountId
      }
      let res = WithdrawalOrderGetList(params);
      return res
    },
    async applyMoney() {
      this.invoiceDialog = true;
      let row = {};
      this.getAccountInfo().then((res) => {
        if (res.data.result.items.length > 0) {
          row = res.data.result.items[0];
          console.log('row', row)
          this.form = {
            capitalAccountId: null,
            bankCardNo: row.bankCardNo,
            bankName: row.bankName,
            bankConcreteName: row.bankConcreteName,
            cardholderName: row.cardholderName,
            provinceId: null,
            province: '',
            cityId: null,
            city: '',
            districtId: null,
            district: '',
          }
          this.form.provinceId = row.provinceId
          this.form.province = row.province
          this.form.city = row.city
          this.form.cityId = row.cityId
          this.form.district = row.district
          this.form.districtId = row.districtId
          this.provinceId = row.provinceId
          this.provinceName = row.province
          this.cityId = row.cityId
          this.cityName = row.city
          this.countyId = row.districtId
          this.countyName = row.district
          console.log('apply', row.provinceName)
        }else{
          this.form = {
            capitalAccountId: null,
            bankCardNo: '',
            bankName: '',
            bankConcreteName: '',
            cardholderName: '',
            provinceId: '',
            province: '',
            cityId: '',
            city: '',
            districtId: null,
            district: null,
          }
          this.provinceId = null
          this.provinceName = null
          this.cityId = null
          this.cityName = null
          this.countyId = null
          this.countyName = null
          console.log('apply')
        }
      })
      console.log('this.form', this.form)
    },
    getResellerAccountDetail(item, index) {
      this.checkedButton = index
      this.currentResellerId = item.Id
      this.getAccountDetail(item.Id);
    },
    async getAllDistributors() {
      let params = {}
      params.SkipCount = 0;
      params.MaxResultCount = 1000;
      let res = await GetAllReseller(params);
      if (res.data.success) {
        let resellerList = [];
        resellerList = res.data.result.items.map((item, index) => {
          return {Id: item.id, name: item.name}
        });
        this.resellerList = resellerList
        if (this.resellerList) {
          if (!this.currentResellerId) {
            this.currentResellerId = this.resellerList[0].Id;
          }
          await this.getAccountDetail(this.currentResellerId);
        }
      } else {
        this.$message.error(res.data.error.message)
      }
    },
    async getAccountDetail(id) {
      if (!id) {
        return this.$message.error('缺少供应商Id, 无法获取改供应商账户详情')
      }
      let params = {}
      params.ResellerId = id
      let res = await CapitalAccountGet(params);
      if (res.data.success) {
        this.currentAccountId = res.data.result.id // 当前账户id
        console.log('当前账户Id', this.currentAccountId)
        this.Balance = res.data.result.balance
        this.Forzen = res.data.result.frozen
        this.WithDraw = res.data.result.withdrawal
      }
    },
    handleClick(tab, event) {

    }
  }
}
</script>

<style scoped>
.supplier {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.account {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.balance {
  width: 150px;
  height: 75px;
  margin-right: 50px;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg_color {
  background-color: #F2F6FC
}

.pt5 {
  margin-top: 5px;
}

.freeze {
  width: 150px;
  height: 75px;
  margin-right: 50px;
}

.check {
  width: 150px;
  height: 75px;
}

.letter_bold {
  font-weight: bold;
}

.fz180 {
  font-size: 18px;
}

.hand {
  cursor: pointer;
}
</style>
